import { defaultsDeep } from "lodash";

export default class Gate{

    constructor(user){
        this.user = user;
    }

     isAdmin(){
        return this.user.roles_id == '1' || this.user.roles_id == '2';
    }

    isSuperAdmin(){
        return this.user.roles_id == '1';
    }
    
    isAllowed(menuName){
        return this.user.roles[menuName] ? true : false;
    }
    
    dataType(userTipe){
        return this.user.data_tipe == userTipe || this.user.data_tipe == '99' ? true : false;
    }

     isNotAdmin(){
        return this.user.roles_id > '2';
    }
    
    /*isAdminOrUser(){
        if(this.user.type === 'user' || this.user.type === 'admin'){
            return true;
        }
    }*/
}

